import { useCallback } from 'react';

import { useTwoFactorAuthenticationPopup } from './useTwoFactorAuthenticationPopup';

export const useRequestTwoFactorAuthentication = () => {
    const twoFactorAuthenticationPopup = useTwoFactorAuthenticationPopup();

    return useCallback(async ({ onCancel, onSuccess }) => {
        // wait for a token from ReCaptcha component within the form
        return await new Promise((resolve, reject) => {
            twoFactorAuthenticationPopup({
                onCancel: () => {
                    onCancel();
                    reject();
                },
                onSuccess: () => {
                    onSuccess();
                    resolve();
                },
                resendHandler: () => {
                    onSuccess();
                    resolve();
                }
            });
        });
    }, [twoFactorAuthenticationPopup]);
};
